import {
  Box,
  Typography,
  Collapse,
  IconButton,
  Card,
  ButtonBase
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useState } from 'react'

const BatchUploadInstructions = () => {
  const [expanded, setExpanded] = useState(false)

  return (
    <Box>
      <Card sx={{ p: 0.5 }}>
        <ButtonBase
          sx={{ width: '100%', justifyContent: 'flex-start' }}
          onClick={() => setExpanded(!expanded)}
          role="expand-button"
        >
          <IconButton component="span">
            <ExpandMoreIcon />
          </IconButton>
          <Typography display="inline">
            <Typography
              component="span"
              sx={{ display: 'inline', color: 'primary.light' }}
            >
              How To:
            </Typography>{' '}
            Batched Orders and Upload Tracking Numbers
          </Typography>
        </ButtonBase>
        <Collapse in={expanded} unmountOnExit>
          <Box sx={{ p: 2, fontSize: '14px' }}>
            Orders are now grouped into Order batches, which are created nightly
            at midnight Pacific Time. This will make it easier for you to keep
            track of which orders have already been fulfilled and which still
            require your attention.
            <p>
              <strong>What's changed:</strong> The CSV that you download will
              contain all of your orders, across every product that you sell
              through StackCommerce, for each day.
            </p>
            To fulfill orders:
            <Box component="ol">
              <li>
                <strong>Download the CSV of orders</strong> for a day's batch
                using the Download buttons below.
                <ul>
                  <li>Here is an example CSV.</li>
                </ul>
              </li>
              <li>
                <strong>Add both the carrier and the tracking numbers</strong>{' '}
                generated by your Shipper in the columns provided.
                <ul>
                  <li>
                    Please import tracking numbers 24 hours prior to packages
                    being picked up by your carrier.
                  </li>
                  <li>The Carrier must be a Valid Carrier.</li>
                  <li>
                    You may add or remove columns in the CSV as needed, as long
                    as the following columns remain and the file format remains
                    a CSV:
                  </li>
                  <ul>
                    <li>Order Num</li>
                    <li>Stack SKU</li>
                    <li>Tracking Number</li>
                    <li>Carrier</li>
                  </ul>
                  We cannot process tracking uploads if any of these columns are
                  missing.
                  <li>
                    Sometimes Microsoft Excel will format tracking numbers and
                    ZIP/Postal Codes incorrectly.
                  </li>
                  <ul>
                    <li>ex. a tracking number may appear as 1.000000E+21</li>
                    <li>
                      ex. a ZIP Code 01234 may lose the leading zero, like 1234
                    </li>
                  </ul>
                  If you see formatting issues, here are instructions on how to
                  fix that.
                </ul>
              </li>
              <li>
                <strong>Click "Import Tracking Numbers"</strong> and select your
                filled-in CSV file. Do not upload an Excel spreadsheet (.xls or
                .xlsx).
                <ul>
                  <li>
                    Customers will automatically receive shipping update emails
                    when you ingest tracking numbers below.
                  </li>
                  <li>
                    <strong>
                      Do not manually send emails directly to customers
                    </strong>{' '}
                    regarding their shipments; they will be notified by
                    StackCommerce.
                  </li>
                </ul>
              </li>
            </Box>
            If you have any issues or feedback please contact our vendor support
            team.
          </Box>
        </Collapse>
      </Card>
    </Box>
  )
}

export default BatchUploadInstructions
